import {
    DELIVERY_FOREIGN_UPS,
    DELIVERY_INPOST, DELIVERY_PACZKOMAT,
    DELIVERY_POS,
    DELIVERY_UPS
} from '../config/martix';

let config = require('../config/validator');

export default class Step1Validator {
    constructor(
        deliveryMethods,
        paymentMethodds,
        inpostData,
        posData,
        discountComponent,
        matrix
    ) {
        this.validators = {};
        this.messages = {
            delivery: {
                notNull : 'Należy wybrać formę dostawy',
                inpost : {
                    notNull : 'Należy wybrać punkt odiboru inpost'
                },
                pos : {
                    notNull : 'Należy wybrać salon Aclari'
                }
            },
            payment : {
                notNull : {

                }
            }
        };

        this.validators = {
            deliveryMethods : deliveryMethods,
            paymentMethods : paymentMethodds,
            inpostComponent : inpostData,
            posComponent : posData,
            isFormSubmitted : false,
            discountComponent: discountComponent,
            functions : {
                methodPicked : null,
                deliveryMethodPicked : function (deliveryMethods) {
                    let isValid = false;
                    let method = null;
                    deliveryMethods.each(function (index, delivery) {
                        if($(this).is(":visible") && $(this).prop('checked') === true) {
                            isValid = true;
                            method = $(this).val();
                        }
                    });

                    this.methodPicked = parseInt(method);

                    return isValid;
                },
                inpostPointPicked : function (inpostComponent) {
                    if (this.methodPicked === DELIVERY_PACZKOMAT) {
                        return JSON.stringify(inpostComponent.getSelectedPoint()) !== JSON.stringify({});
                    }

                    return false;
                },
                posPointPicked : function (posComponent) {
                    if (this.methodPicked === DELIVERY_POS) {
                        return posComponent.isNull() === false;
                    }

                    return false;
                },
                paymentPicked : function (paymentMethods) {
                    let isValid = false;

                    const paymentMethod = matrix.getAvailablePaymentMethods();
                    console.log(paymentMethod);
                    paymentMethods.each(function () {
                        if(paymentMethod && $(this).prop('checked') && paymentMethod.indexOf(parseInt($(this).val())) >= 0 && $(this).parent().parent().hasClass('hidden') === false) {
                            isValid = true;
                        }
                    });

                    return isValid;
                },
                discountCodeEntered: function (discountComponent) {
                    return true;
                }
            }
        };

        this.deliveryHeading = $('#delivery-heading');
        this.discountCodeSelector = $('#basketorder-discount-discountCode');
        this.paymentHeading = $('#payment-heading');
    }

    isFormSubmitted() {
        return this.validators.isFormSubmitted;
    }

    setFormSubmitted(value) {
        this.validators.isFormSubmitted = value;
    }

    methodPicked() {
        return this.validators.functions.methodPicked;
    }

    isDeliverySelected() {
        return this.validators.functions.deliveryMethodPicked(this.validators.deliveryMethods);
    }

    isDiscountCodeEnteredAndValid() {
        const isDiscountCodeEnteredAndValid = this.validators.functions.discountCodeEntered(this.validators.discountComponent);

        const discountAgreement = $('#basketorder-policies-discount').parent().parent();

        if (this.validators.discountComponent.isDiscountEntered === false) {
            this.discountCodeSelector.css('border', '1px solid #cbcbcb');
        } else if (this.validators.discountComponent.isDiscountEntered && this.validators.discountComponent.isDiscountValid) {
            this.discountCodeSelector.css('border', '1px solid #cbcbcb');
            discountAgreement.removeClass('hidden');
        } else if (this.validators.discountComponent.isDiscountValid === false) {
            this.discountCodeSelector.css('border', '1px solid #ff0000');
            discountAgreement.removeClass('hidden');
        } else {
            this.discountCodeSelector.css('border', '1px solid #cbcbcb');
            discountAgreement.addClass('hidden');
        }

        return isDiscountCodeEnteredAndValid;
    }

    isInpostPointSelected() {
        return this.validators.functions.inpostPointPicked(this.validators.inpostComponent);
    }

    isPaczkomatSelected() {
        return this.methodPicked() === DELIVERY_PACZKOMAT;
    }

    isPosPointSelected() {
        return this.validators.functions.posPointPicked(this.validators.posComponent);
    }

    isPosSelected() {
        return this.methodPicked() === DELIVERY_POS;
    }

    isPaymentPicked() {
        return this.validators.functions.paymentPicked(this.validators.paymentMethods);
    }

    isCourierSelected() {
        return this.methodPicked() === DELIVERY_UPS || this.methodPicked() === DELIVERY_FOREIGN_UPS || this.methodPicked() === DELIVERY_INPOST;
    }

    validateSelectingSupply() {
        if (this.isDeliverySelected()) {
            this.deliveryHeading.css('color', 'inherit');

            const isInpostSelected = this.isPaczkomatSelected() && this.isInpostPointSelected();
            const inpostRegulations = $('#basketorder-inpost-chk_inpost_accept-1').parent().parent();
            if(isInpostSelected) {
                inpostRegulations.removeClass('hidden');
            } else {
                inpostRegulations.addClass('hidden');
            }

            if(this.isCourierSelected()) {
                return true;
            } else if (isInpostSelected) {
                return true;
            } else if (this.isPosSelected() && this.isPosPointSelected()) {
                return true;
            } else {
                this.deliveryHeading.css('color', '#ff0000');
                return false;
            }
        } else {
            this.deliveryHeading.css('color', '#ff0000');
            return false;
        }
    }

    validate() {
        if (this.isPaymentPicked() === false) {
            this.paymentHeading.css('color', '#ff0000');
        } else {
            this.paymentHeading.css('color', 'inherit');
        }

        return this.validateSelectingSupply() && this.isPaymentPicked() && this.isDiscountCodeEnteredAndValid();
    }
}
